export default __webpack_public_path__ + "static/pragicts-ai-implementation-services-634e5b3bdc013619cad32508902379d8.jpg";